import AutoQuery from "servicestack/auto-query/auto-query";
import orderLabels from "emun.order/_labels";
import orderConfig from "emun.order/order.config";
import ServiceBus from "servicestack/service-bus";
import CartController from "emun.cart/cart.controller";
import BackorderLinesPrompt from "emun.order/backorders/backorder-lines-prompt"
import orderPicker from "emun.order/backorders/picker/backorder-picker";

export default class BackordersListController extends CartController {
	constructor($cart) {
		super($cart);
		const $ctrl = this;
		$ctrl.labels = orderLabels;
		$ctrl.bus = new ServiceBus();
		var filters = [];
		orderConfig.filters.forEach(function (obj) {
			filters.push(obj);
		});
		$ctrl.query = new AutoQuery({
			url: "QueryCarts.json?IncludeProducts=1",
			orderBy: "-OrderedOn,-Id",
			disableQueryString: !!$ctrl.disableQueryString,
			pageSize: 12,
			criteria: {
				ErpStatus: "BACKORDER"
			},
			filters,
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			autoLoad: true,
			sortOptions: {
				Id: "Order #: Low to High",
				"-Id": "Order #: High to Low",
				"Status,-Id": "Status: A to Z",
				"-Status,-Id": "Status: Z to A",
				"PurchaseOrder,-Id": "PO #: Low to High",
				"-PurchaseOrder,-Id": "PO #: High to Low",
				"VendorLabel,-Id": "Vendor: A to Z",
				"-VendorLabel,-Id": "Vendor: Z to A",
				"CompanyName,-Id": "Customer: A to Z",
				"-CompanyName,-Id": "Customer: Z to A",
				"OrderedOn,-Id": "Order Date: Newest",
				"-OrderedOn,-Id": "Order Date: Oldest",
				"ShipOn,-Id": "Ship Date: Newest",
				"-ShipOn,-Id": "Ship Date: Oldest",
				"GrandTotal,-Id": "Amount: Low to High",
				"-GrandTotal,-Id": "Amount: High to Low",
			}
		});
		$ctrl.$on("cartActivated", (e, cart) => $ctrl.query.load(true));
	}
	openLinesPrompt(order, mode) {
		let $ctrl = this;
		//console.info("BL*** calling bcakorderlines order = ",order);
		return BackorderLinesPrompt({ order: order, mode: mode });
	}
	bulkActions(model) {
		const $ctrl = this;
		return orderPicker({
			title: "Select Orders...",
			view: "table",
			backdrop: false,
			placement: "center",
			criteria: $ctrl.query.criteria,
		}).finally(() => $ctrl.query.load(true));
	}
}
